"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateField = void 0;
var react_1 = __importDefault(require("react"));
var datepicker_1 = require("@react-stately/datepicker");
var datepicker_2 = require("@react-aria/datepicker");
var date_1 = require("@internationalized/date");
var i18n_1 = require("@react-aria/i18n");
var DateField = function (props) {
    var locale = (0, i18n_1.useLocale)().locale;
    var state = (0, datepicker_1.useDateFieldState)(__assign(__assign({}, props), { locale: locale, createCalendar: date_1.createCalendar }));
    var ref = react_1.default.useRef(null);
    var fieldProps = (0, datepicker_2.useDateField)(props, state, ref).fieldProps;
    var QA = props["data-qa"];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", __assign({}, fieldProps, { ref: ref, className: "form-control d-flex align-center" }), state.segments.map(function (segment, i) { return (react_1.default.createElement(DateSegment, { key: i, segment: segment, state: state, id: props.id + "--segment-" + i, qa: QA + "--" + segment.type, "aria-labelledby": props["aria-labelledby"] })); }))));
};
exports.DateField = DateField;
var DateSegment = function (_a) {
    var segment = _a.segment, state = _a.state, id = _a.id, qa = _a.qa, ariaLabel = _a["aria-labelledby"];
    var ref = react_1.default.useRef(null);
    var segmentProps = (0, datepicker_2.useDateSegment)(segment, state, ref).segmentProps;
    return (react_1.default.createElement("div", __assign({}, segmentProps, { ref: ref, id: id, "data-qa": qa, className: "segment " + (segment.isPlaceholder ? "placeholder" : ""), "aria-labelledby": ariaLabel + " " + id }), segment.text));
};
